import React, { useState, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';
import cx from 'classnames';

const Tooltip = ({ className, icon, buttonText, buttonClass, children }) => {
  const [show, setShow] = useState(false);
  const toggleTooltip = useCallback(() => {
    setShow(!show);
  }, [show]);
  const wrapperRef = useRef(null);
  const handleClickOutside = useCallback(event => {
    if (!wrapperRef.current?.contains(event.target)) {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef, handleClickOutside]);

  if (!children) return null;

  return (
    <div className={className} data-testid="tooltip" ref={wrapperRef}>
      <div className="tooltip">
        <button
          className={cx('tooltip__button', {
            [buttonClass]: buttonClass
          })}
          data-testid="tooltip__button"
          onClick={toggleTooltip}
        >
          {icon && <Icon glyph={icon} size="1.6rem" />}
          {buttonText && (
            <span className="tooltip__button-text">{buttonText}</span>
          )}
        </button>
        {show && (
          <div className="tooltip__tooltip" data-testid="tooltip__text">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

Tooltip.defaultProps = {
  icon: '',
  buttonText: '',
  buttonClass: ''
};

Tooltip.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  children: PropTypes.any
};
export default Tooltip;
